import { z } from "zod";

export const InsertScheduleZ = z.object({
  schedule_id: z.string(),
  is_public: z.boolean(),
  schedule_name: z.string(),
});

export type InsertScheduleT = z.infer<typeof InsertScheduleZ>;
